module.exports = __webpack_public_path__ + "img/sms-topup.a0874565.jpg";